import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { HeaderContext } from '../context/HeaderContext';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const Testimonials = () => {
  const { testimonials, imageUrl } = useContext(HeaderContext);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute left-0 right-0 top-0 h-32 bg-gradient-to-r from-green-500 to-blue-600 transform -skew-y-3 origin-top-left -z-10"></div>
      
      <div className="container mx-auto px-4 relative">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-4xl mx-auto"
        >
          <motion.span
            initial={{ scale: 0.9 }}
            whileInView={{ scale: 1 }}
            className="inline-block px-4 py-2 bg-white text-green-600 rounded-full shadow-sm mb-4"
          >
            Student Voices
          </motion.span>
          <motion.h2
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
          >
            Success <span className="text-green-600">Stories</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-xl text-gray-600"
          >
            Hear from our learners about their transformative experiences
          </motion.p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              whileHover={{ y: -10 }}
              className="relative bg-white rounded-xl shadow-lg overflow-hidden group"
            >
              {/* Decorative quote mark */}
              <div className="absolute top-0 right-0 text-gray-100 text-7xl transform translate-x-4 -translate-y-4 group-hover:text-green-100 transition-colors duration-300 z-0">
                <FaQuoteLeft />
              </div>
              
              <div className="relative z-10 p-8">
                {/* Rating */}
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={`text-lg ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}
                    />
                  ))}
                </div>
                
                {/* Testimonial Text */}
                <p className="text-gray-700 mb-6 relative z-10 italic">
                  "{testimonial.feedback}"
                </p>
                
                {/* Author Info */}
                <div className="flex items-center">
                  <div className="relative group-hover:transform group-hover:scale-110 transition-transform duration-300">
                    <img
                      src={`${imageUrl}/${testimonial.image}`}
                      alt={testimonial.name}
                      className="w-14 h-14 rounded-full object-cover border-4 border-white shadow-md"
                    />
                    <div className="absolute inset-0 rounded-full border-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.designation}</p>
                    <p className="text-xs text-gray-400 mt-1">{testimonial.date}</p>
                  </div>
                </div>
              </div>
              
              {/* Hover effect border */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-green-400 rounded-xl m-1 transition-all duration-300 pointer-events-none"></div>
            </motion.div>
          ))}
        </div>

        {/* View All CTA */}
        {/* <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="text-center mt-16"
        >
          <button className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-medium rounded-full shadow-md hover:shadow-lg transition-all hover:from-green-600 hover:to-green-700">
            View All Testimonials
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </motion.div> */}
      </div>
    </section>
  );
};

export default Testimonials;